<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_ii"></a><em class="italic">For James Hayward, dear friend,<br/>fellow historian and chaser of the shadows.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?66f10a9e